/** @format */

import {MouseEvent, useState} from 'react';

import {Box, Typography} from '@mui/material';

import {HelpOutline, HelpOutlined} from '@mui/icons-material';

import {StyledPopover} from 'pages/HomeGrouping/components/StyledPopover';
import {type StatusDataInterface} from 'pages/HomeGrouping/types';

import {statusClasses as classes, StatusRoot as Root} from './styles';

interface Props {
  data: StatusDataInterface;
}

const ProjectStatus = ({data}: Props) => {
  const {title, variant = 'default', PopoverContent, projectTitle} = data;

  const [hover, setHover] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleHintOpen = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setHover(true);
  };

  const handleHintClose = () => {
    setAnchorEl(null);
    setHover(false);
  };

  return (
    <Root colorscheme={variant} data-testid={`help-${projectTitle}`} onClick={handleHintOpen}>
      <Box className={classes.root}>
        <Typography className={classes.title}>{title}</Typography>
        <Box className={classes.helpBox}>
          {hover ? (
            <HelpOutlined className={classes.helpIcon} />
          ) : (
            <HelpOutline className={classes.helpIcon} />
          )}
        </Box>
      </Box>

      <StyledPopover open={Boolean(anchorEl)} anchorEl={anchorEl} onClose={handleHintClose}>
        {PopoverContent}
      </StyledPopover>
    </Root>
  );
};

export {ProjectStatus};
